import { Component, type ErrorInfo, type PropsWithChildren } from 'react';

interface State {
  readonly error: Error | null;
}

export class AppErrorBoundary extends Component<PropsWithChildren, State> {
  public state: State = { error: null };

  public static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[Echo Rebuild]', error, info.componentStack);
  }

  public render(): React.ReactNode {
    if (this.state.error) {
      return (
        <main className="fatal-error" role="alert">
          <p className="eyebrow">Não foi possível abrir esta parte do Echo</p>
          <h1>Seus dados continuam preservados.</h1>
          <p>Recarregue a página. Se o problema continuar, o código abaixo ajuda o suporte a localizar a falha.</p>
          <code>{this.state.error.message}</code>
          <button type="button" onClick={() => window.location.reload()}>Tentar novamente</button>
        </main>
      );
    }
    return this.props.children;
  }
}
